import { render, staticRenderFns } from "./BusinessOwnerInfo.vue?vue&type=template&id=0485f8aa"
import script from "./BusinessOwnerInfo.vue?vue&type=script&lang=js"
export * from "./BusinessOwnerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports